<template>
  <Main>
    <v-row class="pb-8">
      <v-col cols="12" md="9" class="d-flex align-center">
        <p class="gray--text list-region-court__title mb-0">
          {{ titleCourt }}
        </p>
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="pb-5 pb-md-0 pl-md-5"
        v-if="canSeeEditCourt"
      >
        <BaseButton
          color="secondary"
          width="100%"
          outlined
          v-html="'EDITAR TRIBUNAL'"
          :to="{
            name: 'edit court',
            params: { tribunal: $route.params.tribunal }
          }"
        />
      </v-col>
      <v-col cols="12" class="pt-md-3">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="font-weight-bold mb-2 primary--text">
          VARAS
        </p>
      </v-col>
      <v-col cols="12" sm="8" md="9" class="pr-sm-5">
        <BaseFilter
          v-model="filter"
          :textPlaceholder="'Buscar'"
          v-bind="defaultConfigs"
          @search="searchByFilter"
          v-on:keyup="searchByFilterClickEnter"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="3"
        class="pb-5 pb-sm-0"
        v-if="canSeeNewRegionCourt"
      >
        <BaseButton
          class="secondary white--text"
          width="100%"
          @click="newRegionCourt"
        >
          <v-icon class="pr-2">
            fa-plus
          </v-icon>
          ADICIONAR VARA
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="header"
          :items="listRegionCourt"
          no-data-text="Nenhum Vara foi encontrada"
          loading-text="Carregando Varas..."
          :options.sync="options"
          :server-items-length="totalRegionCourt"
          @click:row="editRegionCourt"
        >
          <template v-slot:[`item.codigo`]="{ item }">
            {{ formatCode(item.codigo, 4) }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
          {{ item.status.nome }}
        </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>
<script>
const defaultProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const tableHeaders = [
  { text: "Código", value: "codigo", sortable: true },
  { text: "Descrição", value: "nome", sortable: true },
  { text: "Cidade", value: "cidade", sortable: true },
  { text: "Status", value: "ativo", sortable: true}
];
import { mapState, mapActions } from "vuex";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatCode } from "@/utils/formats.js";
export default {
  data: () => ({
    filter: "",
    header: tableHeaders,
    options: {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 5,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: [],
      sortDesc: []
    },
    formatCode
  }),
  mixins: [CommonPayload, LoadingRequest],
  created() {
    this.fetchItems();
  },
  computed: {
    ...mapState("court", [
      "listRegionCourt",
      "totalRegionCourt",
      "currentCourt"
    ]),
    ...mapState(["userPermissions"]),
    canSeeEditCourt() {
      return this.userPermissions.acoes.some(x => x.id == "editar_tribunal");
    },
    canSeeNewRegionCourt() {
      return this.userPermissions.acoes.some(x => x.id == "criar_tribunal");
    },
    canSeeEditRegionCourt() {
      return this.userPermissions.acoes.some(x => x.id == "editar_tribunal");
    },
    defaultConfigs() {
      return {
        ...defaultProps
      };
    },
    titleCourt() {
      return (
        this.currentCourt.id &&
        `${this.currentCourt.sigla} - ${this.currentCourt.nome}`
      );
    }
  },
  methods: {
    ...mapActions("court", ["requestListRegionCourt", "requestCurrentCourt"]),
    fetchItems() {
      this.withLoading(
        Promise.all([
          this.requestCurrentCourt(this.$route.params.tribunal),
          this.payloadRegionCourt(this.getPayload(this.options, this.filter))
        ])
      );
    },
    fetchRegionCourt(payload) {
      //TODO: fazer integração
      this.withLoading(
        this.requestListRegionCourt(this.payloadRegionCourt(payload))
      );
    },
    searchByFilter() {
      this.fetchRegionCourt(this.getPayload(this.options, this.filter));
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.fetchRegionCourt(this.getPayload(this.options, this.filter));
    },
    editRegionCourt(item) {
      if (this.canSeeEditRegionCourt)
        this.$router.push({
          name: "edit region court",
          params: { tribunal: this.$route.params.tribunal, vara: item.id }
        });
    },
    newRegionCourt() {
      this.$router.push({
        name: "new region court",
        params: { tribunal: this.$route.params.tribunal }
      });
    },
    payloadRegionCourt(payload) {
      return {
        id: this.$route.params.tribunal,
        payload: payload
      };
    }
  },
  watch: {
    options: {
      handler(value) {
        this.fetchRegionCourt(this.getPayload(value, this.filter));
      },
      deep: true
    }
  }
};
</script>
<style lang="sass">
.list-region-court__
  &title
    font-size: 18px
    font-weight: 800
</style>
